import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {PermissionService} from '../_services';

// JS-2084: /orders used to borrow ProjectGuard, which forced View Order into the
// 'project' can-access branch — opening /project/* (projects dashboard, Live View,
// staff allocation, etc.) to every client role. OrdersGuard isolates /orders on
// its own backend branch so the project gate stays agency-only.
@Injectable()
export class OrdersGuard implements CanActivate {

  constructor(private router: Router, private permissionService: PermissionService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) {
      this.router.navigate(['login']);
      return of(false);
    }
    return this.permissionService.canAccessRoute('orders').pipe(
      map(canAccess => {
        if (canAccess === true) {
          return true;
        }
        this.router.navigate(['/']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }
}
